import React from 'react';
import { motion } from 'framer-motion';
export function DescriptionSection() {
  return <section className="py-20 px-6 md:px-12 bg-cream-100 w-full flex justify-center" data-id="element-19">
      <div className="max-w-3xl w-full" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="prose prose-lg prose-sage max-w-none" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-playfair text-bark-900 mb-8 text-center" data-id="element-22">
            ¿Por qué este programa?
          </h2>

          <p className="text-xl font-lato font-bold text-bark-800 mb-6 leading-relaxed" data-id="element-23">
            ¿Se siente cansado/a, con antojos, sueño liviano o estrés
            acumulado—y nota que su cuerpo ya no responde como antes?
          </p>

          <p className="text-lg font-lato text-bark-700 mb-8 leading-relaxed" data-id="element-24">
            <strong data-id="element-25">14 Días de Liberación</strong> es un e-book práctico
            (médico–espiritual) para ayudarle a recuperar estabilidad con pasos
            simples, sin dietas extremas ni rutinas imposibles.
          </p>

          <h3 className="text-2xl font-playfair text-bark-900 mb-6 mt-12" data-id="element-26">
            Este programa le guía durante 14 días con estructura clara:
          </h3>

          <ul className="space-y-4 mb-10 text-lg font-lato text-bark-700 list-disc pl-6" data-id="element-27">
            <li data-id="element-28">
              <strong className="text-bark-800" data-id="element-29">
                Alimentación con el "Plato Fácil"
              </strong>{' '}
              (sin contar calorías)
            </li>
            <li data-id="element-30">
              <strong className="text-bark-800" data-id="element-31">
                7 hábitos de alto impacto
              </strong>{' '}
              para energía y saciedad
            </li>
            <li data-id="element-32">
              <strong className="text-bark-800" data-id="element-33">
                Movimiento suave + fuerza básica
              </strong>{' '}
              apto para principiantes
            </li>
            <li data-id="element-34">
              <strong className="text-bark-800" data-id="element-35">
                Herramientas de calma y sueño
              </strong>{' '}
              (respiración 4–6, pausas de 60 segundos, rutina nocturna)
            </li>
          </ul>

          <div className="bg-white p-8 rounded-xl border border-sage-200 shadow-sm mt-12" data-id="element-36">
            <h4 className="text-xl font-playfair font-bold text-sage-600 mb-3" data-id="element-37">
              Edición Evergreen
            </h4>
            <p className="text-lg font-lato text-bark-700 mb-0" data-id="element-38">
              Usted puede comenzar cualquier día del año.{' '}
              <strong data-id="element-39">El Día 1 es el día que usted comienza.</strong> Si un día
              no se cumple, retome al siguiente.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}